<template lang="html">
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Categorías
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'category_new'})"
            >
              Crear nueva Categoría
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="getCategories()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body p-0" style="padding: 0px">
    <template v-for="category in categories">
      <v-hover>
      <div slot-scope="{ hover }" :key="category.attributes.name" @click="$router.push({name: 'category_edit', params: {id: category.id}})"
        :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__category--row" >
        <p  class="offer_elements__category--row_title">{{ category.attributes.name }}</p>
        <v-icon     @click.stop="deleteCategory(category.id, 'Category')" >delete</v-icon>
      </div>
      </v-hover>
    </template >
  </div>
    <!-- <div class="accessIndex__general_info">
      <div class="accessIndex__reload">
        <p class="accessIndex__text--title" >Sub categorías</p>
      </div>
    </div>
    <div class="offer_elements__category--row_container">
      <template v-for="subcategory in subcategories">
        <v-hover>
        <div slot-scope="{ hover }" :key="subcategory.attributes.name" @click="$router.push({name: 'category_edit', params: {id: subcategory.id}})"
         :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__category--row" >
          <p  class="offer_elements__category--row_title">{{subcategory.parent}}/{{ subcategory.attributes.name }}</p>
          <v-icon     @click.stop="deleteCategory(subcategory.id, 'Subcategory')" color="grey lighten-1">delete</v-icon>
        </div>
        </v-hover>
      </template > -->
    </div>
</template>

<script>
export default {
  data(){
    return{
      categories:[],
      subcategories: []
    }
  },
  methods:{
    showParentCategory(parent_id){
      for (var i = 0; i < this.categories.length; i++) {
        if(this.categories[i].id == parent_id){
          return this.categories[i].attributes.name
        }
      }
    },
    getCategories(){
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('categories/company',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}
        })
        .then(function(response){
          this.categories = response.body.data
          this.subcategories = response.body.included
          var subcategories = []
          for (var i = 0; i < this.subcategories.length; i++) {
            var object = this.subcategories[i]
            object['parent'] = this.showParentCategory(this.subcategories[i].attributes.parent_category_id)
            subcategories.push(object)
          }
          // cl subcategories
          this.subcategories = subcategories
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    deleteCategory(id, type){
      try {
        this.$http.delete('categories/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          if(type == "Category"){
            for (var i = 0; i < this.categories.length; i++) {
              if(this.categories[i].id == id){
                this.categories.splice(i, 1)
              }
            }
          }else{
            for (var i = 0; i < this.subcategories.length; i++) {
              if(this.subcategories[i].id == id){
                this.subcategories.splice(i, 1)
              }
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  },
  mounted(){
    this.getCategories();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/categories/Index.vue